import JsCookies from 'js-cookie';

const BrowserCookies = {
  attributes: JsCookies.attributes,
  converter: JsCookies.converter,

  get: JsCookies.get,

  set: JsCookies.set,

  remove: JsCookies.remove,

  withAttributes: JsCookies.withAttributes,

  withConverter: JsCookies.withConverter,

  getJSON(name) {
    try {
      const value = BrowserCookies.get(name);

      return value ? JSON.parse(value) : null;
    } catch (_e) {
      return null;
    }
  }
};

export default BrowserCookies;
